__turbopack_context__.v({
  "Related": "RelatedArticlesSection-module-scss-module__HZ8nta__Related",
});
